var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSemaineIdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 100",
    style: {
      enableBackground: "new 0 0 200 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3C3C3B;}\n\t.st1{fill:#3175B9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0.9,84.7 3.7,84.7 3.7,84 0.9,84 0.9,82 4.1,82 4.1,81.3 0.1,81.3 0.1,87.5 4.2,87.5 4.2,86.8  0.9,86.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,84c-0.9-0.3-1.5-0.4-1.5-1.1c0-0.6,0.5-1,1.4-1c0.7,0,1.2,0.3,1.5,0.8L9,82.1c-0.5-0.7-1.3-1-2.1-1 c-1.4,0-2.2,0.7-2.2,1.8c0,1.2,1,1.5,2.1,1.8c1,0.2,1.6,0.4,1.6,1.1c0,0.6-0.4,1.1-1.5,1.1c-0.7,0-1.3-0.3-1.7-0.8l-0.6,0.5 c0.6,0.7,1.4,1,2.4,1c1.5,0,2.3-0.7,2.3-1.8C9.1,84.6,8.1,84.2,7,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,84c-0.9-0.3-1.5-0.4-1.5-1.1c0-0.6,0.5-1,1.4-1c0.7,0,1.2,0.3,1.5,0.8l0.6-0.5c-0.5-0.7-1.3-1-2.1-1 c-1.4,0-2.2,0.7-2.2,1.8c0,1.2,1,1.5,2.1,1.8c1,0.2,1.6,0.4,1.6,1.1c0,0.6-0.4,1.1-1.5,1.1c-0.7,0-1.3-0.3-1.7-0.8l-0.6,0.5 c0.6,0.7,1.4,1,2.4,1c1.5,0,2.3-0.7,2.3-1.8C14.1,84.6,13.1,84.2,12.1,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.6,81.2c-1.9,0-2.9,1.5-2.9,3.2c0,1.8,1.1,3.2,2.9,3.2c1.9,0,2.9-1.5,2.9-3.2 C20.5,82.6,19.5,81.2,17.6,81.2z M17.6,86.9c-1.4,0-2.1-1.2-2.1-2.5s0.7-2.5,2.1-2.5s2.1,1.2,2.1,2.5C19.7,85.7,19,86.9,17.6,86.9z "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "25.7,86.1 25.7,86.1 22.3,81.3 21.5,81.3 21.5,87.5 22.3,87.5 22.3,82.5 22.3,82.5 25.8,87.5  26.5,87.5 26.5,81.3 25.7,81.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "34.8,84.7 37.6,84.7 37.6,84 34.8,84 34.8,82 38,82 38,81.3 34,81.3 34,87.5 38.1,87.5 38.1,86.8  34.8,86.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "32.1,86.1 32,86.1 28.6,81.3 27.8,81.3 27.8,87.5 28.6,87.5 28.6,82.5 28.6,82.5 32.1,87.5 32.9,87.5  32.9,81.3 32.1,81.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "169.8,86.5 169.8,86.5 167.9,81.3 167.1,81.3 167,81.3 166.2,81.3 164.4,84.3 164.4,84.3 162.6,81.3  161.7,81.3 164,85.1 164,87.5 164.8,87.5 164.8,85 167,81.4 169.3,87.5 170.2,87.5 172.5,81.3 171.6,81.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "173.8,84.7 176.6,84.7 176.6,84 173.8,84 173.8,82 177,82 177,81.3 173,81.3 173,87.5 177.1,87.5  177.1,86.8 173.8,86.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "178.7,81.3 177.9,81.3 177.9,87.5 181.9,87.5 181.9,86.8 178.7,86.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.5,
    y: 81.3,
    className: "st0",
    width: 0.8,
    height: 6.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "188.8,86.1 188.8,86.1 185.4,81.3 184.5,81.3 184.5,87.5 185.3,87.5 185.3,82.5 185.3,82.5  188.9,87.5 189.6,87.5 189.6,81.3 188.8,81.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "191.6,84.7 194.4,84.7 194.4,84 191.6,84 191.6,82 194.8,82 194.8,81.3 190.8,81.3 190.8,87.5  194.9,87.5 194.9,86.8 191.6,86.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.8,84c-0.9-0.3-1.5-0.4-1.5-1.1c0-0.6,0.5-1,1.4-1c0.7,0,1.2,0.3,1.5,0.8l0.6-0.5c-0.5-0.7-1.3-1-2.1-1 c-1.4,0-2.2,0.7-2.2,1.8c0,1.2,1,1.5,2.1,1.8c1,0.2,1.6,0.4,1.6,1.1c0,0.6-0.4,1.1-1.5,1.1c-0.7,0-1.3-0.3-1.7-0.8l-0.6,0.5 c0.6,0.7,1.4,1,2.4,1c1.5,0,2.3-0.7,2.3-1.8C199.8,84.6,198.8,84.2,197.8,84z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12.4,
    className: "st0",
    width: 6.9,
    height: 31.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,31.7c-3.1,1-4.3,3.2-4.3,5.7c0,3.9,2.8,6.7,7.3,6.7c2.9,0,5.2-1.3,6.5-3.5h0.1l0.2,3h6.4V29.1 c0-4.8-3.3-7.8-10-7.8c-5,0-8,1.7-9.7,5.1l5.2,2.5c0.6-1.6,1.9-2.7,4.1-2.7c2.3,0,3.5,1.2,3.5,3.1v1.3 C18.8,30.7,15.5,30.9,13.1,31.7z M22.4,35.5c0,2.2-1.5,3.9-3.9,3.9c-1.9,0-2.9-1.1-2.9-2.4c0-1.6,1.3-2.1,2.6-2.3 c1.3-0.2,2.9-0.3,4.2-0.4C22.4,34.3,22.4,35.5,22.4,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.9,36.6c0-4.6-4.2-5.8-8.3-6.6c-3.7-0.7-5.2-1-5.2-2.4c0-0.9,1-1.6,3-1.6c2.3,0,5,0.8,7.3,2.2l2.7-4.3 c-2.5-1.5-5.6-2.6-10-2.6c-6.8,0-9.8,3.3-9.8,7c0,4.3,3.7,5.9,8,6.8c3.7,0.7,5.5,1,5.5,2.4c0,1.3-1.5,1.8-3.7,1.8 c-2.6,0-5.5-0.9-7.8-2.5l-3,4.3c2.7,1.7,6,2.8,10.7,2.8C57.1,44.1,60.9,41.1,60.9,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.2,44.1c4.6,0,7.5-1.5,9.5-3.9l-4.2-3.5c-1.4,1.8-3.1,2.5-5,2.5c-3.4,0-4.8-1.8-5.2-4.6h15.1 c0.1-0.7,0.2-1.7,0.2-2.6c0-6.1-3.5-10.7-10.8-10.7c-7.4,0-11.3,4.8-11.3,11.4C61.3,39.5,65.3,44.1,73.2,44.1z M72.6,26.2 c2.8,0,3.9,1.7,4.2,4.4h-8.6C68.5,27.9,69.9,26.2,72.6,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.9,29.3v14.4h6.9V30.1c0-2.2,1.4-3.7,3.8-3.7c2.1,0,3.1,1.3,3.1,2.9v14.4h6.9V28.5c0-4.3-3.1-7.2-7.8-7.2 c-2.9,0-5.3,1.1-6.9,3.3c-1.2-2.1-3.5-3.3-6.5-3.3c-2.9,0-5.1,1.1-6.6,3.4h-0.1l-0.1-2.9h-6.4v21.8H92V30.1c0-2.2,1.4-3.7,3.8-3.7 C97.9,26.4,98.9,27.7,98.9,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.7,31.7c-3.1,1-4.3,3.2-4.3,5.7c0,3.9,2.8,6.7,7.3,6.7c2.9,0,5.2-1.3,6.5-3.5h0.1l0.2,3h6.4V29.1 c0-4.8-3.3-7.8-10-7.8c-5,0-8,1.7-9.7,5.1l5.2,2.5c0.6-1.6,1.9-2.7,4.1-2.7c2.3,0,3.5,1.2,3.5,3.1v1.3 C131.4,30.7,128.1,30.9,125.7,31.7z M135,35.5c0,2.2-1.5,3.9-3.9,3.9c-1.9,0-2.9-1.1-2.9-2.4c0-1.6,1.3-2.1,2.6-2.3 s2.9-0.3,4.2-0.4L135,35.5L135,35.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.8,
    y: 21.8,
    className: "st0",
    width: 6.9,
    height: 21.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 12.4,
    className: "st0",
    width: 7.1,
    height: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.7,30.3c0-2.3,1.5-3.9,4-3.9c2.1,0,3.3,1.4,3.3,3.1v14.1h6.9V28.8c0-4.5-3.1-7.4-7.8-7.4 c-2.9,0-5.3,1.3-6.7,3.5h-0.1l-0.1-3h-6.4v21.8h6.9L161.7,30.3L161.7,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.6,44.1c4.6,0,7.5-1.5,9.5-3.9l-4.2-3.5c-1.4,1.8-3.1,2.5-5,2.5c-3.4,0-4.8-1.8-5.2-4.6h15.1 c0.1-0.7,0.2-1.7,0.2-2.6c0-6.1-3.5-10.7-10.8-10.7c-7.4,0-11.3,4.8-11.3,11.4C177.6,39.5,181.6,44.1,189.6,44.1z M188.9,26.2 c2.8,0,3.9,1.7,4.2,4.4h-8.6C184.8,27.9,186.2,26.2,188.9,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.1,48.2v1.6c0,1.9,1,3,2.7,3c1.2,0,2.1-0.5,2.8-1.6v1.5h0.7V42.2h-0.8v4.4c-0.6-1-1.5-1.5-2.7-1.5 C29.1,45.2,28.1,46.3,28.1,48.2z M28.9,48.3c0-1.5,0.7-2.4,1.9-2.4c1.1,0,2,0.7,2.6,1.9v2.4c-0.6,1.3-1.5,2-2.6,2 c-1.2,0-1.9-0.8-1.9-2.4C28.9,49.8,28.9,48.3,28.9,48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.5,52.9c1.7,0,2.8-0.8,2.9-2.3h-0.8c-0.1,1-0.8,1.6-2.1,1.6c-1.5,0-2.3-0.8-2.3-2.5v-0.5h5.3v-0.9 c0-2-1.1-3.1-3-3.1s-3,1.1-3,3.1v1.5C36.4,51.8,37.5,52.9,39.5,52.9z M37.2,48.4c0-1.7,0.7-2.5,2.2-2.5s2.2,0.8,2.2,2.5v0.2h-4.5 L37.2,48.4L37.2,48.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 49.1,
    className: "st1",
    width: 2,
    height: 26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "7.3,58.4 9.5,49.1 7.5,49.1 5.7,58.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 49.1,
    className: "st1",
    width: 6,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 49.1,
    className: "st1",
    width: 5.6,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37,56.6c-6,0-9.2,4-9.2,9.5c0,5.6,3.3,9.4,9.7,9.4c3.8,0,6.1-1.3,7.7-3.2l-3.4-2.9c-1.1,1.5-2.5,2.1-4.1,2.1 c-2.8,0-3.9-1.5-4.2-3.8h12.3c0.1-0.6,0.1-1.4,0.1-2.1C45.8,60.5,43,56.6,37,56.6z M33.4,64.3c0.2-2.3,1.4-3.7,3.6-3.7 c2.3,0,3.2,1.4,3.4,3.7H33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.1,60.4L68.1,60.4c-1.5-2.3-3.6-3.8-6.6-3.8c-5,0-8.1,4.3-8.1,9.6c0,5.1,2.9,9.3,8,9.3c2.9,0,5.2-1.5,6.6-4 h0.1v3.6h2v-26h-2V60.4z M61.7,73.7c-4.1,0-6.3-3.6-6.3-7.6c0-4.1,2.2-7.7,6.4-7.7c4,0,6.3,3.2,6.3,7.7 C68.1,70.4,65.8,73.7,61.7,73.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.2,56.6c-5.1,0-8.2,4.1-8.2,9.3c0,5.6,3.3,9.6,8.8,9.6c2.9,0,5-1.1,6.7-2.9L87,71.3c-1.3,1.6-3,2.4-5.1,2.4 c-4,0-6.5-2.9-6.8-6.9H89c0.1-0.4,0.1-1.2,0.1-1.5C89.1,60.4,86.1,56.6,81.2,56.6z M75,65.1c0.2-4,2.5-6.8,6.1-6.8 c3.7,0,5.8,2.9,5.9,6.8H75z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "103.8,53.7 116,53.7 116,49.1 97.9,49.1 97.9,75.1 103.8,75.1 103.8,64.7 114.4,64.7 114.4,60.1  103.8,60.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.5,56.9c-0.5-0.2-1.1-0.3-1.7-0.3c-2,0-3.5,1.3-4.5,3.2h-0.1l-0.1-2.9h-5.2v18.2h5.6v-10 c0-2,1.5-3.7,4.3-3.7c0.6,0,1.3,0.1,1.7,0.1C127.5,61.5,127.5,56.9,127.5,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.6,56.6c-4.1,0-6.5,1.4-7.9,4.2l4.2,2.1c0.5-1.3,1.5-2.3,3.4-2.3c1.8,0,2.9,1,2.9,2.5v1.1 c-2.9,0.1-5.7,0.3-7.6,0.9c-2.5,0.8-3.5,2.6-3.5,4.8c0,3.2,2.3,5.6,5.9,5.6c2.4,0,4.2-1.1,5.3-2.9h0.1l0.1,2.5h5.2V63 C143.7,59,141.1,56.6,135.6,56.6z M138.2,68.4c0,1.9-1.2,3.3-3.2,3.3c-1.6,0-2.4-0.9-2.4-2c0-1.3,1.1-1.7,2.1-1.9 c1.1-0.2,2.3-0.3,3.4-0.3L138.2,68.4L138.2,68.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.3,75.1V62.8c0-3.7-2.5-6.2-6.3-6.2c-2.4,0-4.3,1.1-5.5,2.9h-0.1l-0.1-2.5h-5.2v18.2h5.6V64 c0-1.9,1.2-3.3,3.3-3.3c1.7,0,2.6,1.2,2.6,2.6v11.8H163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,71.4c-2.7,0-4-2.3-4-5.3s1.3-5.4,4-5.4c1.7,0,2.8,1,3.6,2.7l4.3-2.3c-1.4-2.8-4-4.5-8.1-4.5 c-6.2,0-9.5,4.1-9.5,9.6c0,5.4,3.4,9.4,9.5,9.4c4.2,0,6.8-1.9,8.2-4.6l-4.1-2.2C177.5,70.3,176.3,71.4,174.5,71.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.2,56.6c-6,0-9.2,4-9.2,9.5c0,5.6,3.3,9.4,9.7,9.4c3.8,0,6.1-1.3,7.7-3.2l-3.4-2.9 c-1.1,1.5-2.5,2.1-4.1,2.1c-2.8,0-3.9-1.5-4.2-3.8H200c0.1-0.6,0.1-1.4,0.1-2.1C200,60.5,197.1,56.6,191.2,56.6z M187.6,64.3 c0.2-2.3,1.4-3.7,3.6-3.7c2.3,0,3.2,1.4,3.4,3.7H187.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.3,81.3L81,87.5h-0.9l-2.3-6.2h0.9l1.9,5.2l0,0l1.8-5.2H83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87,85.8h-2.8l-0.7,1.7h-0.9l2.5-6.2h1l2.5,6.2h-0.9L87,85.8z M86.8,85.1l-1.1-2.9l0,0l-1.1,2.9H86.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.4,81.3h0.8v5.5h3.2v0.7h-4V81.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.2,81.3h2.1c2.1,0,3.1,1.4,3.1,3.1c0,1.9-1.2,3.1-3.1,3.1h-2.2L96.2,81.3L96.2,81.3z M98.3,86.8 c1.4,0,2.3-0.8,2.3-2.4c0-1.7-1-2.4-2.4-2.4H97v4.8H98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.5,81.3h0.8l-0.6,2.2h-0.6L102.5,81.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.6,81.2c1.9,0,2.9,1.4,2.9,3.2c0,1.8-1,3.2-2.9,3.2s-2.9-1.4-2.9-3.2S104.7,81.2,106.6,81.2z M106.6,86.9 c1.4,0,2.1-1.2,2.1-2.5s-0.7-2.5-2.1-2.5s-2.1,1.2-2.1,2.5C104.5,85.7,105.2,86.9,106.6,86.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.7,87.5v-6.2h0.8v6.2H110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.4,86.6l0.6-0.5c0.4,0.5,1,0.8,1.7,0.8c1,0,1.5-0.4,1.5-1c0-0.7-0.6-0.9-1.6-1.1c-1-0.3-2-0.6-2-1.8 c0-1.1,0.8-1.8,2.2-1.8c0.9,0,1.6,0.3,2.1,1l-0.6,0.5c-0.3-0.5-0.8-0.8-1.5-0.8c-0.9,0-1.4,0.4-1.4,1c0,0.7,0.6,0.8,1.5,1.1 c1.1,0.3,2.1,0.6,2.1,1.8c0,1.1-0.8,1.8-2.3,1.8C113.8,87.6,113,87.3,112.4,86.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.1,87.5v-6.2h4V82h-3.2v2h2.8v0.7h-2.8v2.1h3.3v0.7C122.2,87.5,118.1,87.5,118.1,87.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemaineIdf);
export default __webpack_public_path__ + "static/media/semaine-idf.d91f854f45f3f92d7f1aed0e2b0c155a.svg";
export { ForwardRef as ReactComponent };